export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') },
	'downloads': { id: 'downloads', page: 'toutHorizontal', getter: () => import(/* webpackChunkName: 'toutHorizontal' */ 'components/bolt/toutHorizontal/toutHorizontal') },
	'myFirstMovie': { id: 'myFirstMovie', page: 'customScroll', getter: () => import(/* webpackChunkName: 'customScroll' */ 'components/bolt/customScroll/customScroll') }
};
import text from 'components/bolt/text/text';
import toutHorizontal from 'components/bolt/toutHorizontal/toutHorizontal';
import gallery from 'components/bolt/gallery/gallery';
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "synopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis', parent: 'boltHome' },
	{ id: 'boltFeaturedVideos', getter: () => import(/* webpackChunkName: "featuredVideos" */ 'components/bolt/featuredVideos/featuredVideos'), component: 'featuredVideos', parent: 'boltHome' },
	{ id: 'intro', isPreloaded: true, component: text, parent: 'myFirstMovie' },
	{ id: 'downloads', isPreloaded: true, component: toutHorizontal, parent: 'myFirstMovie' },
	{ id: 'boltGallery', isPreloaded: true, component: gallery, parent: 'myFirstMovie' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
